// Arive LOS constants for frontend display

export const ARIVE_LOAN_STAGES = [
  { value: 'APPLICATION_INTAKE', label: 'Application Intake', color: 'green', order: 1 },
  { value: 'QUALIFICATION', label: 'Qualification', color: 'teal', order: 2 },
  { value: 'PREAPPROVED', label: 'Pre-Approved', color: 'cyan', order: 3 },
  { value: 'LOAN_SETUP', label: 'Loan Setup', color: 'blue', order: 4 },
  { value: 'DISCLOSURE_SENT', label: 'Disclosure Sent', color: 'blue', order: 5 },
  { value: 'UNDERWRITING_SUBMITTED', label: 'UW Submitted', color: 'orange', order: 6 },
  { value: 'APPROVED_WITH_CONDITION', label: 'Approved w/ Conditions', color: 'yellow', order: 7 },
  { value: 'RE_SUBMITTAL', label: 'Re-Submittal', color: 'orange', order: 8 },
  { value: 'CLEAR_TO_CLOSE', label: 'Clear to Close', color: 'green', order: 9 },
  { value: 'DOCS_OUT', label: 'Docs Out', color: 'green', order: 10 },
  { value: 'DOCS_SIGNED', label: 'Docs Signed', color: 'green', order: 11 },
  { value: 'LOAN_FUNDED', label: 'Funded', color: 'green', order: 12 },
  { value: 'BROKER_CHECK_RECEIVED', label: 'Broker Check', color: 'green', order: 13 },
  { value: 'COMMISSION_PAID', label: 'Commission Paid', color: 'green', order: 14 },
  { value: 'SUSPENDED', label: 'Suspended', color: 'red', order: 15 },
];

export const ARIVE_LEAD_STATUSES = [
  { value: 'NEW', label: 'New', color: 'blue' },
  { value: 'CONTACTED', label: 'Contacted', color: 'cyan' },
  { value: 'QUALIFIED', label: 'Qualified', color: 'purple' },
  { value: 'LOST', label: 'Lost', color: 'red' },
];

export const ARIVE_TRACKER_NAMES = {
  APPRAISAL: 'Appraisal',
  HOI: 'HOI',
  TITLE: 'Title',
  CD: 'CD Status',
  FUNDING_WIRE: 'Funding Wire',
  SIGNED_DOCS_WITH_LENDER: 'Final Loan Docs',
  PAYROLL: 'Commissions / Payroll',
  CLIENT_REVIEW: 'Client Review',
};

export function getAriveStageLabel(stageValue) {
  const stage = ARIVE_LOAN_STAGES.find((s) => s.value === stageValue);
  return stage ? stage.label : stageValue || 'Unknown';
}

export function getAriveStageColor(stageValue) {
  const stage = ARIVE_LOAN_STAGES.find((s) => s.value === stageValue);
  return stage ? stage.color : 'gray';
}

export function getAriveLeadStatusLabel(statusValue) {
  const status = ARIVE_LEAD_STATUSES.find((s) => s.value === statusValue);
  return status ? status.label : statusValue || 'Unknown';
}

export function buildAriveDeepLink(entityType, ariveId, storedDeepLink) {
  if (storedDeepLink) return storedDeepLink;
  if (!ariveId) return null;
  if (entityType === 'loan') {
    return `https://future.myarive.com/app/loans/${ariveId}/loan-center`;
  }
  return `https://future.myarive.com/app/leads/${ariveId}/`;
}
